import { render } from "./RestrictedWidth.vue?vue&type=template&id=553679f1"
const script = {}

import exportComponent from "/codebuild/output/src900218826/src/production-ready-serverless-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__